import React from 'react'

import {
  Dialog,
  DialogContent,
  DialogActions,
  Stack,
  Button,
  IconButton,
  Typography,
  Box,
  useTheme,
  alpha,
} from '@mui/material'
import { Close as CloseIcon, PowerSettingsNew as PowerIcon } from '@mui/icons-material'

import { useDisclosure } from '@/hooks/useDisclosure'
import { useStopCharging } from '@/modules/Station/StartChargingModal/hooks/useStartCharging/useStopCharging'

export interface ChargingStopModalProps {
  modalMethods: ReturnType<typeof useDisclosure>
  stopChargingMethods: ReturnType<typeof useStopCharging>
  onClose?: () => Promise<void>
}

export const ChargingStopModal: React.FC<ChargingStopModalProps> = ({ modalMethods, stopChargingMethods, onClose }) => {
  const theme = useTheme()

  const handleClose = async () => {
    modalMethods?.close()
    await onClose?.()
  }

  return (
    <Dialog
      open={modalMethods.isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          sx: { borderRadius: 3, padding: 1, minWidth: 320 },
        },
      }}
    >
      <IconButton
        aria-label="fechar"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 4,
          top: 4,
        }}
      >
        <CloseIcon color="disabled" sx={{ fontSize: '16px' }} />
      </IconButton>

      <DialogContent>
        <Stack spacing={2.5} alignItems="center">
          <Stack alignItems="center" spacing={1.5} sx={{ mt: 1 }}>
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                bgcolor: alpha(theme.palette.warning.main, 0.12),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <PowerIcon sx={{ fontSize: 36, color: 'warning.main' }} />
            </Box>
            <Typography variant="h6" fontWeight="700" textAlign="center" color="text.primary">
              Finalizar o carregamento?
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ px: 1 }}>
              A sessão de carregamento será encerrada e você paga só o que consumiu.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ pb: 2.5 }}>
        <Stack width="100%" direction="column" spacing={1}>
          <Button
            color="error"
            variant="contained"
            onClick={stopChargingMethods.confirmChargingStop}
            sx={{ width: '100%', borderRadius: 4 }}
            disableElevation
            loading={stopChargingMethods.isPending}
          >
            Finalizar
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={handleClose}
            sx={{ width: '100%', borderRadius: 4 }}
            disableElevation
            disabled={stopChargingMethods.isPending}
          >
            Voltar
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
